import {GameWinPresentationInitialState} from 'src/winpresentation/states/GameWinPresentationInitialState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {WildMeterEvents} from 'src/wildmeter/WildMeterEvents';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';

export class GameWinPresentationBigWinWithMultiplierState extends GameWinPresentationInitialState {

	protected setupEvents(): void {
		super.setupEvents();

		this.on(WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED, this.onWinMeterWinExitAnimationFinished);
	}

	/*
	1) win amount moves swiftly from win field to center reels
	2) Multiplier moves shortly after and hits win.
	3a) big win presentation kicks in, counting from unmultiplied amount
	 */

	protected startInitialWinPresentation(): void {
		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);

		this.emit(GameWinPresentationEvents.COUNTING_STARTED, logic.getLastAvalancheRunningTotal());
		this.view.playWinNumberCounter(logic.getLastAvalancheRunningTotal(),
			false, // no countup here
			0,
			false);

		this.emit(WinPresentationEvents.INITIAL_ANIMATION_STARTED);
	}

	protected onWinMeterWinExitAnimationFinished(): void {
		this.emit(GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED);
		this.onWinAnimationFinished();
	}

	protected tryToFinishWinPresentation(): void {

	}
}



// WEBPACK FOOTER //
// ./src/winpresentation/states/GameWinPresentationBigWinWithMultiplierState.ts